import { render, staticRenderFns } from "./bankcardUpload.vue?vue&type=template&id=037ae69a"
import script from "./bankcardUpload.vue?vue&type=script&lang=js"
export * from "./bankcardUpload.vue?vue&type=script&lang=js"
import style0 from "./bankcardUpload.vue?vue&type=style&index=0&id=037ae69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports